<div class="alert alert-warning alert--small" *ngIf="filtering">
  You are seeing only {{ noticeCount }} of {{ group.noticeCount }} occurrences
  that match your selected filters.
  <a
    class="alert-link"
    uiSref="groups-show"
    [uiParams]="{
      projectId: project.id,
      groupId: group.id,
      tab: 'notice-detail'
    }"
    [uiOptions]="{ inherit: false, reload: true }"
    >Reset filters</a
  >
  to see all occurrences.
</div>
<div class="occurrence-header">
  <div class="occurrence-header__link" *ngIf="!hasOneOccurrence()">
    <button
      class="btn btn--link-color btn--no-shadow"
      (click)="toggleOccurrences()"
    >
      <i
        class="glyphicon glyphicon-ab-menu-hamburger occurrence-link__icon"
      ></i>
      View Occurrence List
    </button>
  </div>
  <div class="occurrence-header__title">
    <span class="d-none d-xl-inline">Occurrence</span>&nbsp;&#35;{{
      occurrence.id
    }}
  </div>
  <div class="occurrence-header__pager" *ngIf="!hasOneOccurrence()">
    <span [hidden]="!loading"> <ab-spinner-inline></ab-spinner-inline></span
    ><span class="btn-group">
      <button
        class="btn"
        type="button"
        (click)="loadOccurrence('first')"
        [disabled]="!hasPrevOccurrence || loading"
      >
        <i class="glyphicon glyphicon-angle-double-left"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="loadOccurrence('prev')"
        [disabled]="!hasPrevOccurrence || loading"
      >
        <i class="glyphicon glyphicon-angle-left"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="loadOccurrence('next')"
        [disabled]="!hasNextOccurrence || loading"
      >
        <i class="glyphicon glyphicon-angle-right"></i>
      </button>
      <button
        class="btn"
        type="button"
        (click)="loadOccurrence('last')"
        [disabled]="!hasNextOccurrence || loading"
      >
        <i class="glyphicon glyphicon-angle-double-right"></i></button
    ></span>
  </div>
</div>
<hr />
<ngb-accordion
  [activeIds]="openPanelIds"
  [destroyOnHide]="false"
  (panelChange)="panelChange($event)"
>
  <ngb-panel id="details">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.details }"
      ></i
      ><span>Details</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <table class="kv-table">
        <tr>
          <td class="kv-table__key kv-table__kv--no-top-padding">When</td>
          <td class="kv-table__value kv-table__kv--no-top-padding">
            <ab-timestamp
              class="ab-timestamp"
              [time]="occurrence.createdAt"
              [placement]="'right auto'"
            ></ab-timestamp>
          </td>
        </tr>
        <tr *ngIf="occurrence.errors && occurrence.errors[0].message">
          <td class="kv-table__key">Message</td>
          <td class="kv-table__value">{{ occurrence.errors[0].message }}</td>
        </tr>
        <tr class="url" *ngIf="occurrence.context.url">
          <td class="kv-table__key">URL</td>
          <td class="kv-table__value">
            <span *ngIf="occurrence.context.httpMethod">{{
              occurrence.context.httpMethod
            }}</span
            ><a
              class="kv-table__url external-link"
              href="{{ occurrence.context.url }}"
              target="_blank"
              >{{ occurrence.context.url }}</a
            >
          </td>
        </tr>
        <tr *ngIf="backtrace() && backtrace()[0].file">
          <td class="kv-table__key">File</td>
          <td class="kv-table__value">
            <ab-file-line
              [file]="backtrace()[0].file"
              [line]="backtrace()[0].line"
              [repoUrl]="repoUrl"
              [gitRevision]="deployRevision"
              [rootDir]="occurrence.context.rootDirectory"
            ></ab-file-line>
          </td>
        </tr>
        <tr *ngIf="occurrence.context.userAddr">
          <td class="kv-table__key">User address</td>
          <td class="kv-table__value">
            {{ occurrence.context.userAddr }}
            <ab-country
              *ngIf="occurrence.context.userCountry"
              [country]="occurrence.context.userCountry"
              [code]="occurrence.context.userCountryCode"
            ></ab-country>
          </td>
        </tr>
        <tr>
          <td class="kv-table__key">Remote address</td>
          <td class="kv-table__value">
            {{ occurrence.context.remoteAddr }}
            <ab-country
              *ngIf="occurrence.context.remoteCountry"
              [country]="occurrence.context.remoteCountry"
              [code]="occurrence.context.remoteCountryCode"
            ></ab-country>
          </td>
        </tr>
        <tr *ngIf="occurrence.context.userAgent">
          <td class="kv-table__key">User agent</td>
          <td class="kv-table__value">
            <ab-user-agent
              [raw]="occurrence.context.userAgent"
              [info]="occurrence.context.userAgentInfo"
            ></ab-user-agent>
          </td>
        </tr>
      </table>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="backtrace" *ngIf="backtrace() && backtrace().length > 0">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.backtrace }"
      ></i
      ><span>Backtrace</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <ab-backtrace
        [errors]="occurrence.errors"
        [repoUrl]="repoUrl"
        [gitRevision]="deployRevision"
        [rootDir]="occurrence.context.rootDirectory"
        [codeHunksEnabled]="tierFeatures.code_hunks"
        *ngIf="tierFeatures"
      ></ab-backtrace>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="parameters" *ngIf="!isEmpty(occurrence.params)">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.parameters }"
      ></i
      ><span>Parameters</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <pre>{{ occurrence.params | json }}</pre>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="environment" *ngIf="!isEmpty(occurrence.environment)">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.environment }"
      ></i
      ><span>Environment</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <pre>{{ occurrence.environment | json }}</pre>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="session" *ngIf="!isEmpty(occurrence.session)">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.session }"
      ></i
      ><span>Session</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <pre>{{ occurrence.session | json }}</pre>
    </ng-template>
  </ngb-panel>
  <ngb-panel
    class="breadcrumbs"
    id="contextHistory"
    *ngIf="!isEmpty(occurrence.context.history)"
  >
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.contextHistory }"
      ></i
      ><span>Breadcrumbs</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <div *ngIf="tierFeatures === undefined">
        <ab-spinner></ab-spinner>
      </div>
      <ab-breadcrumbs
        *ngIf="tierFeatures"
        [contextHistory]="occurrence.context.history"
        [featureEnabled]="tierFeatures.breadcrumbs"
      ></ab-breadcrumbs>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="context" *ngIf="!isEmpty(occurrence.context)">
    <ng-template ngbPanelTitle="ngbPanelTitle"
      ><i
        class="card-title-content__icon glyphicon glyphicon-ab-plus"
        [ngClass]="{ 'is-opened': isOpen.context }"
      ></i
      ><span>Context</span></ng-template
    >
    <ng-template ngbPanelContent="ngbPanelContent">
      <pre>{{ occurrence.context | json }}</pre>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
